import { useEffect, useState } from "react";
import { isBrowser } from "./runtime";

let cachedReactQuill = null;
let imageResizeRegistered = false;

function loadReactQuillModule() {
  const reactQuillModule = require("react-quill");
  return {
    ReactQuill: reactQuillModule.default || reactQuillModule,
    Quill: reactQuillModule.Quill,
  };
}

export function useClientReactQuill(options = {}) {
  const { enableImageResize = false } = options;
  const [ReactQuillComponent, setReactQuillComponent] = useState(
    () => cachedReactQuill
  );

  useEffect(() => {
    if (!isBrowser) {
      return;
    }

    try {
      const { ReactQuill, Quill } = loadReactQuillModule();

      if (enableImageResize && Quill && !imageResizeRegistered) {
        const imageResizeModule = require("quill-image-resize-module-react");
        const ImageResize = imageResizeModule.default || imageResizeModule;
        Quill.register("modules/imageResize", ImageResize);
        imageResizeRegistered = true;
      }

      cachedReactQuill = ReactQuill;
      setReactQuillComponent(() => ReactQuill);
    } catch (error) {
      console.error("Failed to load rich text editor:", error);
      setReactQuillComponent(null);
    }
  }, [enableImageResize]);

  return ReactQuillComponent;
}
